import React, { useState } from "react";
import { Row, Col, Form, Modal, Button } from "react-bootstrap";
import axios from "axios";
import config from "../config/config";
import { ToastContainer, toast } from "react-toastify";
import LoadingSpinner from "../Components/LoadingSpinner";
import moment from "moment";

const EditModal = (props) => {
  const { editModal, setEditModal, rowsDataName, rowsDataType, rowsDataDate, rowsId, setReloadData } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [name, setName] = useState(rowsDataName || "");
  const [type, setType] = useState(rowsDataType || "");
  const [date, setDate] = useState(moment(rowsDataDate).format('YYYY-MM-DD'));

  const handleCloseModal = () => {
    setEditModal(false);
  };

  const EditHolidayData = async () => {
    setIsLoading(true);
    let path = config.siteUrl;
    var token = localStorage.getItem('access_token');
    var result = await axios
      .post(
        path + `/common/update-holiday/${rowsId}`,
        {
          name: name,
          type: type,
          date: date,
        },
        {
          headers: { 'Content-Type': 'application/json' },
        }
      )
      .then((response) => {
        toast.success(response?.data?.message)
        setIsLoading(false) 
        setReloadData(true);
        return response.data; 
      })
      .catch((error) => {
        console.error("error:", error); 
        return null;
      });
    return result;
  };

  return (
    <>
      <div>
        <LoadingSpinner isLoading={isLoading} />
        <Modal size="lg" show={editModal} onHide={handleCloseModal}>
          <Modal.Header closeButton>
            <Modal.Title className="text-center w-100">
              Add New Holiday Details Here
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row className="mb-3">
                <Col sm={4}>
                  <Form.Label>Holiday Name</Form.Label>
                </Col>
                <Col sm={8}>
                  <Form.Control
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    type="text"
                    placeholder="Enter holiday name"
                  />
                </Col>
              </Row>
              <Row className="mb-3">
                <Col sm={4}>
                  <Form.Label>Holiday Date</Form.Label>
                </Col>  
                <Col sm={8}>
                  <Form.Control
                    type="date"
                    value={date}
                    onChange={(e) => setDate(e.target.value)}
                  />
                </Col>
              </Row>
              <Row className="mb-3">
                <Col sm={4}>
                  <Form.Label>Holiday Type</Form.Label>
                </Col>
                <Col sm={8}>
                  <Form.Select
                    value={type}
                    onChange={(e) => setType(e.target.value)}
                  >
                    <option value="">Select type</option>
                    <option value="HL">HL</option>
                    <option value="CL">CL</option>
                    <option value="PL">PL</option>
                    <option value="RH">RH</option>
                    <option value="Public holiday">Public holiday</option>
                  </Form.Select>
                </Col>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="success"
              onClick={() => {
                EditHolidayData();
                handleCloseModal();
              }}
              className="px-3"
            >
              Save
            </Button>
            <Button variant="danger" onClick={handleCloseModal} className="px-3">
              Exit
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};

export default EditModal;
